/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid } from '@mui/material';
import ErrorBoundary from '../Errors/ErrorBoundary';
import { componentsConfig } from '../Config/ComponentsConfig';
import { ErrorMessage } from '../Errors/ErrorMessage';
import ErrorTemplate from '../Errors/ErrorTemplate';

/**
 * BaseAppFrame Component
 *
 * This AppFrame does not store any kind of data in the session storage
 *
 * @param configKey
 * @returns {JSX.Element}
 * @constructor
 */
function BaseAppFrame({ configKey }) {
  const config = componentsConfig[configKey];

  // Dynamically import the component based on the configuration
  const MainComponent = React.lazy(() => import(`./${config.content.component}`));
  return (
    <Grid container direction="row">
      {/* add here a static header if necessary */}
      <Grid
        item
        xs
        sx={{
          overflowY: 'auto',
          flex: 1,
        }}
      >
        <Container maxWidth={false} disableGutters>
          <ErrorBoundary fallback={<ErrorTemplate />}>
            <React.Suspense fallback={<div>Loading...</div>}>
              <MainComponent {...config.content.params} />
            </React.Suspense>
            <ErrorMessage />
          </ErrorBoundary>
        </Container>
      </Grid>
      {/* add here a static footer if necessary */}
    </Grid>
  );
}

BaseAppFrame.propTypes = {
  configKey: PropTypes.string.isRequired,
};

export default BaseAppFrame;
